module.exports = __webpack_public_path__ + "img/voice-icon2.38eace9.png";